import { inject, InjectionToken } from '@angular/core';
import { bytesToMb } from '@simOn/utils/helpers';
import { AssetAttachmentLimitsToken, AttachmentSizeLimitsToken } from '@simOn/utils/tokens';
import { SupportedImageLabels, SupportedImageTypes } from './supported-extensions.const';

export const UPLOAD_IMAGE_TOKEN = new InjectionToken<{
  uploadDescription: string;
  supportedFormats: SupportedImageLabels[];
  supportedFormatsDescription: string;
  maxSize: number;
  maxUpload: number;
}>('Upload image token', {
  factory: () => {
    const maxUpload = inject(AssetAttachmentLimitsToken).imgMaxNumber;
    const maxSize = inject(AttachmentSizeLimitsToken).imgMaxSize;
    return {
      uploadDescription: $localize`:@@UPLOAD_LABEL_2:Maximum number of files: ${maxUpload}  (${bytesToMb(maxSize)} MB each)`,
      supportedFormatsDescription: 'JPEG, BMP, PNG, TIFF, WEBP, GIF, JFIF',
      supportedFormats: SupportedImageTypes.map(({label}) => label),
      maxSize,
      maxUpload
    } as const;
  }
});
